import { html, nothing, unsafeCSS } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@/components/icon";
import "@/components/shortcut";
import EkoElement from "@/utilities/element";
import style from "./command-menu-footer-item.css?inline";

@customElement("eko-command-menu-footer-item")
export class CommandMenuFooterItem extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  @property({ reflect: true }) icon?: string;
  @property({ reflect: true }) shortcut?: string;

  private renderShortcut() {
    if (!this.shortcut) return nothing;

    const isAlt = this.shortcut === "alt";
    const isCtrl = this.shortcut === "ctrl";
    const isShift = this.shortcut === "shift";

    return html`<eko-shortcut
      ?alt=${isAlt}
      ?ctrl=${isCtrl}
      ?shift=${isShift}
      part="shortcut"></eko-shortcut>`;
  }

  render() {
    return html`
      <div class="eko-command-menu-footer-item__shortcut" part="shortcut">
        ${this.renderShortcut()}
        ${this.icon ? html`<eko-icon name=${this.icon} part="icon"></eko-icon>` : nothing}
      </div>
      <slot></slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-command-menu-footer-item": CommandMenuFooterItem;
  }
}

export default CommandMenuFooterItem;
